import { Controller } from "@hotwired/stimulus"

// Перестраивает список «Для кого» по выбранному «Чем делимся».
// Допустимые роли лежат в data-targets у <option> субъекта.
export default class extends Controller {
  static targets = ["subject", "target"]
  static values = { labels: Object }

  connect() {
    this.update()
  }

  update() {
    const option = this.subjectTarget.selectedOptions[0]
    const roles = option ? JSON.parse(option.dataset.targets || "[]") : []

    this.targetTarget.innerHTML = ""
    roles.forEach((role) => {
      const element = document.createElement("option")
      element.value = role
      element.textContent = this.labelsValue[role] || role
      this.targetTarget.appendChild(element)
    })
    this.targetTarget.disabled = roles.length === 0
  }
}
